const consts = {
    default_route: '/statistics',
    fetchAppProps: {
        dispatches: [
            {name: 'fetchUserSettings', params: {}},
            {name: 'fetchUnitsIcons', params: {}},
            {name: 'fetchUnitsHwTypesAll', params: {}},
            {name: 'fetchUnitsHwTypesSettings', params: {}},
            {name: 'fetchUnitsTypes', params: {}},
            //{name: 'fetchUnitsXTypes', params: {}},

            {name: 'fetchAppUser', params: {}},

            {name: 'fetchAppObjects', params: [
                {name: 'fetchUnitsLmsgsAll', params: {lite: true, withAddress: 0, withSensors: 0}},
                {name: 'fetchVideoStatusesAll', params: {}},
                {name: 'fetchUnitsAll', params: {}},

                {name: 'fetchUsersAll', params: {}},
                {name: 'fetchUsersCustomizesAll', params: {}},
            ]},
        ],
    },
    reloadAppProps: {
        dispatches: [
            {name: 'reloadUnitsAll', params: {}},
            {name: 'reloadUnitsLmsgsAll', params: {lite: true, withAddress: 0, withSensors: 0}},
            {name: 'fetchVideoStatusesAll', params: {}},

            // {name: 'reloadUsersAll', params: {}},
            // {name: 'reloadUsersCustomizesAll', params: {}},
        ],
        commits: [
        ],
    },
    fetchByTimer: {
        dispatches: [
            //{name: 'fetchAppUserChanged', eachT: 30, params: {}},

            {name: 'fetchUnitsChanged', eachT: 30, params: {}},
            {name: 'fetchUnitsLmsgsChanged', eachT: 30, params: {lite: true, withAddress: 0, withSensors: 0}},//'filter[changed]': 60,
            {name: 'fetchVideoStatusesChanged', eachT: 30, params: {}},

            {name: 'fetchUsersChanged', eachT: 30, params: {}},
            {name: 'fetchUsersCustomizesChanged', eachT: 30, params: {}},

            // {name: 'fetchGeopointsChanged', eachT: 30, params: {}},
            // {name: 'fetchGeozonesChanged', eachT: 30, params: {}},
        ],
    },
    // fetchByPage: {
    //     dispatches: [
    //         // {name: 'fetch***', eachT: 10, params: {}, page: '***'},
    //     ]
    // },
    api: {
        user: {
            //fields: [],
            expand: ['units_of_measure', 'settings', 'notifications_settings', 'user_creator', 'is_admin', 'is_super_admin', 'limited', 'parents', 'hide_menu', 'dealers_hide_menu', 'admin_hide_menu', 'dealers_admin_hide_menu', 'head__logo', 'shifts'],
        },
        units_lite: {
            fields: ['id','creator','hw_type','hw_id','name','isRemoved','access_right','parent__id'],
            expand: ['user_creator', 'created', 'access_right'], //,counters
        },
        units: {
            //fields: ['id','hw_type','hw_id','name','type','unit_icon','icon','max_speed','phone'],
            expand: ['user_creator', 'created', 'removed', 'access_right', 'cameras'], //,counters
        },
        units_groups: {
            // fields: ['id',],
            expand: ['access_right','user_creator'],
        },
        users_lite: {
            //fields: [],
            expand: ['user_creator', 'is_admin', 'is_super_admin', 'limited', 'last__login', 'access_right'],
        },
        users: {
            //fields: ['id','creator','login','email','phone','legal_name','time_zone','dst','status'],
            expand: ['user_creator', 'is_admin', 'is_super_admin', 'limited', 'parents'
                , 'apikeys', 'hide_menu', 'dealers_hide_menu', 'admin_hide_menu', 'dealers_admin_hide_menu'
                , 'last__login', 'changed__time', 'access_right'],//'customize','portal_url','admin_url',
        },
        customizes:{
            expand: ['license',],
        },
        geopoints: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'], //'points'
        },
        geopoints_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },
        geozones: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'], //'points'
        },
        geozones_lite: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right'], //'points'
        },
        geozones_groups_lite: {
            fields: ['id', 'name', 'geozones'],
            // expand: [],
        },
        geozones_groups: {
            //fields: ['id', 'name', 'descr', 'color', 'line', 'perimeter', 'radius', 'surface_area', 'docs_surface_area', 'maxSpeed'],
            expand: ['access_right', 'user_creator'],
        },

        notifications: {
            //fields: [],
            expand: ['units','units-groups','geozones','geopoints', 'user_creator'],
        },
        template_reports: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        services: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        drivers: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },
        drivers_groups: {
            //fields: [],
            expand: ['access_right', 'user_creator'],
        },

        units_msgs: {
            // fields: ['id',],
            expand: [],
        },

        events: {
            //fields: [],
            expand: [],
        },
        events_lite: {
            //fields: [],
            expand: [],
        },
        video_events: {
            //fields: [],
            expand: [],
        },
        video_events_lite: {
            //fields: [],
            expand: [],
        },
        video_requests: {
            //fields: [],
            expand: ['image'],
        },
        video_requests_lite: {
            //fields: [],
            expand: [],
        },
        video_records: {
            //fields: [],
            expand: [],
        },
        video_records_lite: {
            //fields: [],
            expand: [],
        },

    },
    components: {
        UnitEdit: {
            defaults: {
                options: {
                    components: [
                        'UnitEdit_Options_intuit',
                        // 'UnitEdit_Icon_intuit',
                        'UnitEdit_AddInfo_intuit',
                        'UnitEdit_Sensors_intuit',
                    ]
                },
            },
            xCargoUnit: {
                options: {
                    components: [
                        'UnitEdit_Options_intuit',
                        'UnitEdit_Delivery',
                        'UnitEdit_xCargoSensors',
                    ]
                }
            }
        },
        UserEdit: {
            defaults: {
                options: {
                    components: [
                        'UserEdit_Options_intuit',
                        'UserEdit_Menus',
                        'UserEdit_Api_intuit',
                        'UserEdit_Units_list',
                        //'UserEdit_Password',
                        // 'UserEdit_Menus' ??
                    ]
                }
            }
        },
        UserCustomizeEdit: {
            defaults: {
                options: {
                    components: [
                        'UserCustomizeEdit_options',
                    ]
                }
            }
        },
    },
}

export default consts